export enum StateSlice {
    ROUTER = 'router',
    SESSION = 'session',
    TRACKING = 'tracking'
  }
  